var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.75C7.99456 14.75 8.94839 14.3549 9.65165 13.6517C10.3549 12.9484 10.75 11.9946 10.75 11V4.25C10.75 3.25544 10.3549 2.30161 9.65165 1.59835C8.94839 0.895088 7.99456 0.5 7 0.5C6.00544 0.5 5.05161 0.895088 4.34835 1.59835C3.64509 2.30161 3.25 3.25544 3.25 4.25V11C3.25 11.9946 3.64509 12.9484 4.34835 13.6517C5.05161 14.3549 6.00544 14.75 7 14.75ZM4.75 4.25C4.75 3.65326 4.98705 3.08097 5.40901 2.65901C5.83097 2.23705 6.40326 2 7 2C7.59674 2 8.16903 2.23705 8.59099 2.65901C9.01295 3.08097 9.25 3.65326 9.25 4.25V11C9.25 11.5967 9.01295 12.169 8.59099 12.591C8.16903 13.0129 7.59674 13.25 7 13.25C6.40326 13.25 5.83097 13.0129 5.40901 12.591C4.98705 12.169 4.75 11.5967 4.75 11V4.25ZM7.75 17.708V20H10.75V21.5H3.25V20H6.25V17.708C4.59997 17.5235 3.07581 16.7374 1.96891 15.4999C0.862021 14.2624 0.25005 12.6603 0.25 11H1.75C1.75 12.3924 2.30312 13.7277 3.28769 14.7123C4.27226 15.6969 5.60761 16.25 7 16.25C8.39239 16.25 9.72774 15.6969 10.7123 14.7123C11.6969 13.7277 12.25 12.3924 12.25 11H13.75C13.7499 12.6603 13.138 14.2624 12.0311 15.4999C10.9242 16.7374 9.40003 17.5235 7.75 17.708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.8b4b1b60f4635920aa2a9788055f3081.svg";
export { ForwardRef as ReactComponent };